import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { ViewLoader } from '~/components';
import { useAuth } from './AuthProvider';

const SigninCallback: FC = () => {
  const { targetUrl, isAuthenticated, loading } = useAuth();
  let redirect = targetUrl;

  if (loading) {
    return <ViewLoader initial />;
  }

  if (isAuthenticated) {
    const url = new URL(targetUrl, window.location.origin);

    url.searchParams.set('login', 'true');

    redirect = `${url.pathname}${url.search}`;
  }

  return <Navigate to={redirect} />;
};

export default SigninCallback;
